const SIGNED_MARKERS = [
  'x-amz-algorithm',
  'x-amz-signature',
  'x-amz-credential',
  'x-goog-algorithm',
  'x-goog-signature',
  'googleaccessid',
  'x-goog-date',
]

const DEFAULT_HOSTS = ['amazonaws.com.cn', 'amazonaws.com', 'storage.googleapis.com']

export const isSignedStorageUrl = (url: string): boolean => {
  if (!url) return false
  const lower = url.toLowerCase()
  if (SIGNED_MARKERS.some(m => lower.includes(m))) return true
  return DEFAULT_HOSTS.some(h => lower.includes(h))
}
